import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  CircularProgress,
  Typography,
  Alert
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { ChangePasswordPayload, changePasswordRequest } from "../api/changePass";

interface ChangePasswordProps {
  onSuccess?: () => void;
}

export default function ChangePassword({ onSuccess }: ChangePasswordProps) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (newPassword !== confirmPassword) {
      setError("Le nuove password non corrispondono");
      return;
    }

    try {
      setLoading(true);
      const payload: ChangePasswordPayload = {
        old_password: oldPassword,
        new_password: newPassword,
      };        
      await changePasswordRequest(payload);
      setSuccess("Password cambiata con successo");
    } catch (err) {
      setError("Errore durante il cambio della password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}

      <TextField
        type={showPassword ? "text" : "password"}
        label="Password attuale *"
        value={oldPassword}
        onChange={(e) => setOldPassword(e.target.value)}
        fullWidth
        required
        variant="outlined"
        sx={{ backgroundColor: "#f0f2f5", borderRadius: 2 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword((v) => !v)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        }}
      />

      <TextField
        type={showPassword ? "text" : "password"}
        label="Nuova password *"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        fullWidth
        required
        variant="outlined"
        sx={{ backgroundColor: "#f0f2f5", borderRadius: 2 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword((v) => !v)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        }}
      />

      <TextField
        type={showPassword ? "text" : "password"}
        label="Conferma nuova password *"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        fullWidth
        required
        variant="outlined"
        sx={{ backgroundColor: "#f0f2f5", borderRadius: 2 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword((v) => !v)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        }}
      />

      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={loading}
        sx={{
          mt: 1,
          borderRadius: 2,
          fontWeight: 600,
          background: "#1c3477",
          "&:hover": {
            background: "#152a5a"
          }
        }}
      >
        {loading ? <CircularProgress size={22} color="inherit" /> : "AGGIORNA"}
      </Button>
    </Box>
  );
}